// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"GridSection_gridContainer__WRDsN","icon":"GridSection_icon__64AAJ"};